<script>
  import {navigate} from 'svelte-routing'
  import store from '~/Library/store'
  export let footer = false

  function goToContact(){
    store.setAttribute('show_mobile_menu', false)
    navigate('/contact', {replace:true})
  }
</script>

<button class="bg-accent" class:footer on:click={goToContact}>Contact</button>

<style lang="scss">
  button {
    border-radius: 0.75rem;
    height: 42px;
    width: 94px;
    border: none;
    color: white;
    cursor: pointer;
    &.footer {
      height: auto;
      width: auto;
      border-radius: 2rem;
      font-size: 1.125rem;
      font-weight: bold;
      margin-top: 2rem;
      padding: 1.125rem 2.75rem;
    }
  }
</style>